// extracted by mini-css-extract-plugin
module.exports = {"container":"e_AB","sizeSmall":"e_BB","on":"e_CB","handle":"e_DB","variantGrey":"e_EB","variantPrimary":"e_FB"};